import { User } from './tournament';

/** Distinguishes capacity-counting registration tickets from free roster member tickets. */
export enum TicketRoleEnum {
  REGISTRATION = 1,
  ROSTER_MEMBER = 2,
}

export type Ticket = {
  id: number;
  tournamentId: number;
  classId: number;
  ticketStartId: string;
  token: string;
  tokenImage: string;
  type: number;
  validFromAt: string | null;
  validToAt: string | null;
  paymentId: string;
  isApprove: boolean;
  price: number;
  currency: string;
  createdAt: string;
  updatedAt: string;
  teamId: number;
  payerId: number;
  status: number;
  /** Defaults to REGISTRATION when omitted (older API responses). */
  ticketRole?: TicketRoleEnum;
  user: User;
};
